import React, { useState, useEffect } from 'react';
import './CarDiagram.css';

const CarDiagram = ({ selectedWheels = [], onWheelSelection, disabled = false }) => {
  const [wheels, setWheels] = useState({
    LF: false,
    RF: false,
    LR: false,
    RR: false
  });

  // Update local state when selectedWheels prop changes
  useEffect(() => {
    const newWheels = {
      LF: selectedWheels.includes('LF'),
      RF: selectedWheels.includes('RF'),
      LR: selectedWheels.includes('LR'),
      RR: selectedWheels.includes('RR')
    };
    setWheels(newWheels);
  }, [selectedWheels]);

  const handleWheelClick = (wheelPosition) => {
    if (disabled) return;

    const newWheels = {
      ...wheels,
      [wheelPosition]: !wheels[wheelPosition]
    };
    
    setWheels(newWheels);
    
    // Convert to array of selected wheel positions
    const selectedPositions = Object.keys(newWheels).filter(pos => newWheels[pos]);
    
    // Call the callback with the selected positions
    if (onWheelSelection) {
      onWheelSelection(selectedPositions);
    }
  };

  return (
    <div className="car-diagram-container">
      <div className="car-diagram">
        {/* Wheels */}
        <div className={`wheel wheel-LF ${wheels.LF ? 'selected' : ''} ${disabled ? 'disabled' : ''}`}
             onClick={() => handleWheelClick('LF')}
             title="Left Front">
          <div className="wheel-label">LF</div>
        </div>
        
        <div className={`wheel wheel-RF ${wheels.RF ? 'selected' : ''} ${disabled ? 'disabled' : ''}`}
             onClick={() => handleWheelClick('RF')}
             title="Right Front">
          <div className="wheel-label">RF</div>
        </div>
        
        <div className={`wheel wheel-LR ${wheels.LR ? 'selected' : ''} ${disabled ? 'disabled' : ''}`}
             onClick={() => handleWheelClick('LR')}
             title="Left Rear">
          <div className="wheel-label">LR</div>
        </div>
        
        <div className={`wheel wheel-RR ${wheels.RR ? 'selected' : ''} ${disabled ? 'disabled' : ''}`}
             onClick={() => handleWheelClick('RR')}
             title="Right Rear">
          <div className="wheel-label">RR</div>
        </div>
      </div>
      
    </div>
  );
};

export default CarDiagram;
